"use client";

import Lottie, { LottieComponentProps } from "lottie-react";

const LottieComponent = (props: LottieComponentProps) => {
  return <Lottie {...props} />;
};

export default LottieComponent;
